import { datasource } from "./datasource";

export const proshopDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("proshop", {
    model: {
      id: "id",
      auditable: true,
      syncable: true,
      byProshop: true,
      fields: {
        id: {
          type: "string",
        },
        name: {
          type: "string",
        },
        address: {
          type: "string",
        },
        country: {
          type: "string",
        },
        state: {
          type: "string",
        },
        city: {
          type: "string",
        },
        postal_code: {
          type: "string",
        },
        logo: {
          type: "string",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
      },
    },
  });
